import React, { useState, useEffect, useContext } from 'react';
import paymentHistoryData from './dummy_data.json';
import styles from './PaymentHistory.module.css';
import { formatDate, formatDateTime } from '../../Profile/ReferralHistory/dateFormatter';
import { convertToBengaliNumber } from '../../BannerPart3/helper';
import { fetchPaymentHistory } from '../../../services';
import { dataContext } from '../../../App';
import activityLogSubmission from '../../../helper/activitylog';

const PaymentHistory = () => {
  const {token,playerData} = useContext(dataContext);
  const [data, setData] = useState([]);
  useEffect(() => {
    activityLogSubmission("payment_history");
  }, []);

  useEffect(() => {
    fetchPaymentHistory(token).then((res) => {
      setData(res);
    });
  }, [token]);

  const displayedServiceTypes = new Set();

  return (
    <div className={styles.paymentHistory}>
      <div className={styles.title}>পেমেন্ট হিস্টরি</div>
      <div className={styles.historyList}>
        {[...data].reverse().map((payment) => {
          let shouldDisplayNextPaymentDate = false;
          const serviceType = payment.serviceType;

          const isCurrentlySubscribed = (
            (serviceType === 'Daily' && playerData?.isSubscribe) ||
            (serviceType === 'Tournament' && playerData?.isSubscribeTournament) ||
            (serviceType === 'BCS' && playerData?.isSubscribeBcs) ||
            (serviceType === 'Sports' && playerData?.isSubscribeSports)
          );

          if (isCurrentlySubscribed && !displayedServiceTypes.has(serviceType)) {
            shouldDisplayNextPaymentDate = true;
            displayedServiceTypes.add(serviceType);
          }

          return (
            <div key={payment.id} className={styles.historyItemWrapper}>
              <div className={styles.historyItem}>
                <div className={styles.paymentInfo}>
                  <div className={styles.subsType}>{serviceType === 'Daily' ? 'কুইজ প্রতিদিন' :
                    serviceType === 'Tournament' ? 'টুর্নামেন্ট' :
                    serviceType}</div>
                  <div className={styles.amount}>৳{convertToBengaliNumber(payment.amount)} (ট্যাক্স সহ)</div>
                </div>
                <div className={styles.paymentAmount}>
                  <div className={styles.dateTime}>{formatDate(payment.paymentDate)}</div>
                  <span className={styles.paymentDuration}>{convertToBengaliNumber(payment.duration)} দিনের জন্য</span>
                </div>
              </div>
              {shouldDisplayNextPaymentDate && (
                <div style={{fontSize:'13px'}}>Next Payment Date: {formatDateTime(payment.nextPaymentDate)}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PaymentHistory;